import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from 'src/app/modules/shared/security/services/auth-guard.service';
import { AuthInterceptor } from './modules/shared/security/services/AuthInterceptor.service';
import { SecurityHeadersInterceptor } from './core/interceptors/security-headers.interceptor';
import { AppComponent } from './app.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { NgxUiLoaderModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LoginService } from './core/services/login.service';
import { AppService } from './core/services/app.service';
import esBr from '@angular/common/locales/es';
import { AppRoutingModule } from './app-routing.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpLoaderFactory, TranslatesProcertService } from './modules/shared/translates/translates-procert.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

registerLocaleData(esBr);

@NgModule({
  declarations: [],
  imports: [
    MatSidenavModule,
    BrowserModule,
	  BrowserAnimationsModule,
	  FormsModule,
    BrowserModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: true }),
    HttpClientModule,
    ReactiveFormsModule ,
    BrowserAnimationsModule,
    NgxJsonViewerModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({ loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] } }),
    NgxUiLoaderModule,
    NgxUiLoaderHttpModule,
    MatSnackBarModule,
    MatDialogModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    AppComponent
  ],
  providers: [
    AuthGuard,
    TranslatesProcertService,
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: function(appSerive: AppService) {
        return new AuthInterceptor(appSerive)
      },
      multi: true,
      deps: [LoginService, AppService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SecurityHeadersInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})

export class AppModule { }